export default __webpack_public_path__ + "ded7272e46103967504b2f082ee3a36d.svg";